import { createContext, useContext } from 'react';
import type { MieterPanelKey } from '../../../../components/immobilien/mieterWidgets';
import type { MieteTeile } from '../../../../lib/immobilien/einheitDetail';
import type { LedgerEntry } from '../../../../lib/mietkonto/typen';
import type { MieterStatus, PortalZustand } from '../../../../lib/mieter/liste';
import type { MieterBereich, MieterDetailDaten } from '../../../../lib/mieter/useMieterDetail';

/** Abgeleitete Werte der Mieter-Detailseite – einmal berechnet, von Widgets und Panels gelesen. */
export interface MieterSeitenWert {
  daten: MieterDetailDaten;
  fehler: Partial<Record<MieterBereich, string>>;
  name: string;
  vorname: string;
  objektName: string;
  einheit: string;
  status: MieterStatus;
  portal: PortalZustand;
  email: string;
  beginn: string | null;
  ende: string | null;
  heute: string;
  miete: MieteTeile;
  /** Zustand des gemeinsamen Mietkontos; 'ohne' = keinem Objekt zugeordnet */
  mietkonto: 'laedt' | 'nicht_eingerichtet' | 'fehler' | 'ohne' | 'ok';
  konto: LedgerEntry | null;
  personen: number;
  zusammenfassung: string;
  oeffnePanel: (key: MieterPanelKey) => void;
  neuLaden: () => void;
  /** Formulare mit ungespeicherten Änderungen melden hier ihre Rückfrage an (null = abmelden). */
  registriereVerlassen: (rueckfrage: (() => void) | null) => void;
  /** Panel schließen (ohne Rückfrage) */
  schliessePanel: () => void;
}

export const MieterSeitenKontext = createContext<MieterSeitenWert | null>(null);

export function useMieterSeite(): MieterSeitenWert {
  const w = useContext(MieterSeitenKontext);
  if (!w) throw new Error('useMieterSeite außerhalb der Mieter-Detailseite');
  return w;
}
